import { useState } from 'react';
import { crewsAPI } from '../services/api';
import { useNotifications } from '../components/notifications';

export const useCrewOperations = (crews, setCrews, selectedCrew, setSelectedCrew) => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingCrew, setEditingCrew] = useState(null);
  const { showToast, showConfirm } = useNotifications();
  const [newCrew, setNewCrew] = useState({
    name: '',
    boat_type: '8+',
    description: '',
    is_experimental: false,
    training_group_id: null,
    members: [],
    rigging_config: null,
  });

  const resetNewCrew = () => {
    setNewCrew({
      name: '',
      boat_type: '8+',
      description: '',
      is_experimental: false,
      training_group_id: null,
      members: [],
      rigging_config: null,
    });
  };

  const handleCreateCrew = async () => {
    try {
      const createdCrew = await crewsAPI.createCrew(newCrew);
      setCrews([...crews, createdCrew]);
      setIsCreateModalOpen(false);
      resetNewCrew();
      showToast('Crew created successfully', 'success');
    } catch (error) {
      console.error('Error creating crew:', error);
      showToast('Failed to create crew', 'error');
    }
  };

  const handleDeleteCrew = async (crewId) => {
    const confirmed = await showConfirm(
      'Are you sure you want to delete this crew? This action cannot be undone.',
      'Delete Crew'
    );

    if (!confirmed) return;

    try {
      await crewsAPI.deleteCrew(crewId);
      setCrews(crews.filter((crew) => crew.id !== crewId));
      if (selectedCrew?.id === crewId) {
        setSelectedCrew(null);
      }
      showToast('Crew deleted successfully', 'success');
    } catch (error) {
      console.error('Error deleting crew:', error);
      showToast('Failed to delete crew', 'error');
    }
  };

  const handleEditCrew = (crew) => {
    const crewWithOriginalStatus = {
      ...crew,
      originalIsExperimental: crew.is_experimental, // Track original status
    };
    setEditingCrew(crewWithOriginalStatus);
    setIsEditModalOpen(true);
  };

  const handleUpdateCrew = async () => {
    try {
      const updatedCrew = await crewsAPI.updateCrew(editingCrew.id, editingCrew);
      setCrews(crews.map((crew) => (crew.id === editingCrew.id ? updatedCrew : crew)));
      if (selectedCrew?.id === editingCrew.id) {
        setSelectedCrew(updatedCrew);
      }
      setIsEditModalOpen(false);
      setEditingCrew(null);
      showToast('Crew updated successfully', 'success');
    } catch (error) {
      console.error('Error updating crew:', error);
      showToast('Failed to update crew', 'error');
    }
  };

  return {
    isCreateModalOpen,
    setIsCreateModalOpen,
    isEditModalOpen,
    setIsEditModalOpen,
    editingCrew,
    setEditingCrew,
    newCrew,
    setNewCrew,
    handleCreateCrew,
    handleDeleteCrew,
    handleEditCrew,
    handleUpdateCrew,
  };
};
